import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import next from "../assets/nextjs.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import redux from "../assets/redux.png";
import angular from "../assets/angular.png";
import bootstrap from "../assets/bootstrap.png";
import firebase from "../assets/firebase.png";
import ts from "../assets/ts.png";
import nest from "../assets/nest.png";

export const skills = [
  {
    id: 1,
    image: html,
    title: "HTML5",
    style: "shadow-orange-600",
  },
  {
    id: 2,
    image: css,
    title: "CSS3",
    style: "shadow-blue-900",
  },
  {
    id: 3,
    image: javascript,
    title: "Javascript",
    style: "shadow-yellow-500",
  },
  {
    id: 4,
    image: react,
    title: "React",
    style: "shadow-blue-500",
  },
  {
    id: 5,
    image: react,
    title: "React Native",
    style: "shadow-blue-700",
  },
  {
    id: 6,
    image: redux,
    title: "Redux",
    style: "shadow-purple-900",
  },
  {
    id: 8,
    image: angular,
    title: "Angular",
    style: "shadow-red-600",
  },
  {
    id: 7,
    image: next,
    title: "Nextjs",
    style: "shadow-white",
  },

  {
    id: 13,
    image: ts,
    title: "Typescript",
    style: "shadow-blue-400",
  },
  {
    id: 9,
    image: bootstrap,
    title: "Bootstrap",
    style: "shadow-purple-700",
  },
  {
    id: 10,
    image: tailwind,
    title: "Tailwind",
    style: "shadow-sky-800",
  },
  {
    id: 11,
    image: github,
    title: "Git",
    style: "shadow-gray-500",
  },
  {
    id: 12,
    image: firebase,
    title: "Firebase",
    style: "shadow-orange-400",
  },
  {
    id: 14,
    image: nest,
    title: "Nestjs",
    style: "shadow-red-500",
  },
];
